export const getLatestOrders = (apiInstance, clientId, statusCode) => {
	let requestParameters = {
		method: "GET",
		mode: "cors",
		headers: apiInstance.headers,
	};

	return fetch(
		`${apiInstance.apiURL}/Orders/GetLatestOrders?clientId=${clientId}&statusCode=${statusCode}`,
		requestParameters
	);
};

export const getOrderById = (apiInstance, clientId, orderId) => {
	let requestParameters = {
		method: "GET",
		mode: "cors",
		headers: apiInstance.headers,
	};

	return fetch(
		`${apiInstance.apiURL}/Orders/GetOrderById/${orderId}?clientId=${clientId}`,
		requestParameters
	);
};

export const getInvoice = (apiInstance, data) => {
	let requestParameters = {
		method: "GET",
		mode: "cors",
		headers: apiInstance.headers,
	};

	return fetch(
		`${apiInstance.apiURL}/Orders/GetInvoice?clientId=${data.clientId}&ocId=${data.orderId}`,
		requestParameters
	);
};
